require('./subscribeNowController');
"use strict";

angular.module('app.home.subscribeNow', [
    'app.home.subscribeNow.subscribeNowController'
])
    .config([
        '$stateProvider', 'PRODUCT',
        function ($stateProvider, product) {

          let subTemplate = 'components/home/subscribeNow/subscribeNowView.html';
          if (product.Code != 'htv') {
            subTemplate = 'assets/templates/' + product.Code + '/subscribeNow/subscribeNowView.html';
          }

          $stateProvider.state('app.home.subscribeNow', {
              url: '/subscribe_now',
              templateUrl: subTemplate,
              controller: 'app.home.subscribeNow.subscribeNowController',
              title: 'Welcome'
          });
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/home/subscribeNow/subscribeNow.js